import React from 'react'
import { CircularProgress } from '@material-ui/core'
import { GpModalShell, GpButton } from '../../components/gp'
import './TermsModal.css'

export default function TermsModal(props) {
    const handleAgree = () => {
        props.setTermsAccepted(true)
        props.handleClose()
    }

    return (
        <GpModalShell
            open={props.open}
            onClose={props.handleClose}
            title={props.title || 'Terms & Conditions'}
            width={720}
            footer={
                props.showActions && (
                    <>
                        <GpButton variant="ghost" onClick={props.handleClose}>
                            Cancel
                        </GpButton>
                        <GpButton
                            variant="primary"
                            onClick={handleAgree}
                            disabled={props.loading}
                        >
                            I agree
                        </GpButton>
                    </>
                )
            }
        >
            {props.loading && (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: '48px 0',
                    }}
                >
                    <CircularProgress size={32} style={{ color: 'var(--gp-brand)' }} />
                </div>
            )}
            {!props.loading && (
                <div
                    className="gp-terms-body"
                    style={{
                        font: 'var(--gp-body)',
                        color: 'var(--gp-ink)',
                    }}
                >
                    {props.termsText && (
                        <div dangerouslySetInnerHTML={{ __html: props.termsText }} />
                    )}
                    {props.privacyText && (
                        <div dangerouslySetInnerHTML={{ __html: props.privacyText }} />
                    )}
                </div>
            )}
        </GpModalShell>
    )
}
